module.exports = __webpack_public_path__ + "static/media/map.4a076ebc.png";